import React, { type JSX, useEffect, useState } from 'react'

export const ImageLoader = ({ src, fallbackSrc, placeholder }: { src: string; fallbackSrc: string; placeholder?: JSX.Element; alt?: string }) => {
  const [loading, setLoading] = useState(true)
  const [currentSrc, setCurrentSrc] = useState(fallbackSrc)

  useEffect(() => {
    if (src) {
      const imageToLoad = new Image()
      imageToLoad.src = src
      imageToLoad.onload = () => {
        setLoading(false)
        setCurrentSrc(src)
      }
      imageToLoad.onerror = () => {
        setLoading(false)
        setCurrentSrc(fallbackSrc)
      }
    }
  }, [src, fallbackSrc])

  return !loading ? (
    <object
      style={{
        opacity: loading ? 0.5 : 1,
        transition: 'opacity .15s linear',
      }}
      aria-label='landing image'
      data={currentSrc}
      type='image/svg+xml'
    ></object>
  ) : (
    <>{placeholder}</>
  )
}
